// extracted by mini-css-extract-plugin
export default {"proyectosContainer":"Proyectos_proyectosContainer__r69OS","title":"Proyectos_title__3sVSH","descripcionProyectos":"Proyectos_descripcionProyectos__x0Ml-"};